/******************************************************************************
 * @Author                : Hamza Damene                                      *
 * @CreatedDate           : 2025-03-19 15:00:00                               *
 * @LastEditors           : Hamza Damene                                      *
 * @LastEditDate          : 2025-03-19 15:00:00                               *
 *****************************************************************************/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { t } from "i18next";

/**
 * Props pour le composant OnCallSection
 */
interface OnCallSectionProps {
  workorder: EasyTech.Workorder;
}

/**
 * Section d'astreinte du workorder
 * @param workorder - Données du workorder
 * @param informationHook - Hook contenant la logique d'édition
 * @returns Composant React pour la section d'astreinte
 */
export function OnCallSection({ workorder }: OnCallSectionProps) {
  return (
    <>
      <div className="field">
        <label>{t("common:onCallDuty")}</label>
        <Typography>{workorder?.onCallDuty ? "Oui" : "Non"}</Typography>
      </div>
    </>
  );
} 